<div class="p-fluid">
  <kodit-field fieldLabel="Datum prometa" fieldLabelFor="dupliranje-datum-prometa">
    <kodit-calendar
      formCtrlId="dupliranje-datum-prometa"
      [formCtrl]="form.controls.datumPrometa"
      ctrlPlaceholder="Prema pravilu za datum prometa"
    ></kodit-calendar>
  </kodit-field>
  <kodit-field fieldLabel="Napomena" fieldLabelFor="dupliranje-napomena">
    <p-editor
      id="dupliranje-napomena"
      [formControl]="napomenaCtrl"
      placeholder="Ostavite prazno da se zadrži napomena sa originala"
      [style]="{ height: '150px' }"
    >
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button type="button" class="ql-bold" aria-label="Bold"></button>
          <button type="button" class="ql-italic" aria-label="Italic"></button>
        </span>
      </ng-template>
    </p-editor>
    <kodit-error-info-max-length
      [formCtrl]="napomenaCtrl"
    ></kodit-error-info-max-length>
  </kodit-field>
  <div class="p-d-flex p-flex-column">
    <span class="note">
      *** Biće kreirano {{ racunIds.length }} {{ vrstaRacunaLabel }} u statusu Nacrt, sa stavkama i cenama sa
      originala. Dobićete notifikaciju kada se dupliranje završi.
    </span>
  </div>
</div>
